import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { InnerPrimaryButton } from 'cstar-react-primitives/lib/redux-form/buttons/PrimaryButton';

import { setCartStatusReady } from '../cart/cartModule';
import ModalFooter from '../modal/ModalFooter';
import ModalHeader from '../modal/ModalHeader';
import ModalContent, { ModalContentInner } from '../modal/ModalContent';
import { ModalContainer } from '../modal/ModalWrapper';
import { removePromoRewards, setRejectedPromo } from '../promo/promoModule';
import { getActivePromo } from '../promo/promoSelectors';
import { paymentReset } from '../payment/paymentModule';

import { promoErrorModalMessages as messages } from './promoMessages';


export const PROMO_ERROR_MODAL_ID = 'promo-unapplied';

export const PromoErrorModal = ({
    intl,
    modalId,
    errorMessage,
    errorHeading,
    cashbotName,
    removeRewards,
    addInvalidPromo,
    activePromoCode,
    resetPayment,
    goToCart,
    submit,
    isCreditCardPayment
}) => {
    const modalProps = {
        modalId,
        cashbotName,
        contentLabel: errorMessage,
        isOpen: true
    };
    const sharedButtonClickActions = () => {
        addInvalidPromo(activePromoCode);
        removeRewards();
    };
    const onContinueButtonClick = () => {
        sharedButtonClickActions();
        
        
        if (isCreditCardPayment) {
            submit();
        } else {
            resetPayment();
        }
    };
    const onEditButtonClick = () => {
        sharedButtonClickActions();
        resetPayment();
        goToCart();
    };
    const editButtonProps = {
        cashbotName,
        type: 'button',
        onClick: onEditButtonClick,
        btnText: intl.formatMessage(messages.editCartButtonText)
    };
    const continueButtonProps = {
        cashbotName,
        type: 'button',
        onClick: onContinueButtonClick,
        btnText: isCreditCardPayment
            ? intl.formatMessage(messages.continueButtonText)
            : intl.formatMessage(messages.closeButtonText)
    };
    return (
        <ModalContainer {...modalProps}>
            <ModalHeader headerText={errorHeading} />
            <ModalContent>
                <ModalContentInner>
                    <FormattedMessage {...errorMessage} />
                </ModalContentInner>
            </ModalContent>
            <ModalFooter>
                <div className="btn-row">
                    <InnerPrimaryButton {...editButtonProps} />
                    <InnerPrimaryButton {...continueButtonProps} />
                </div>
            </ModalFooter>
        </ModalContainer>
    );
};

PromoErrorModal.defaultProps = {
    cashbotName: 'promo-unapplied-modal',
    modalId: PROMO_ERROR_MODAL_ID,
    isCreditCardPayment: false
};

PromoErrorModal.propTypes = {
    
    intl: intlShape.isRequired,
    
    activePromoCode: PropTypes.string.isRequired,
    
    removeRewards: PropTypes.func.isRequired,
    addInvalidPromo: PropTypes.func.isRequired,
    resetPayment: PropTypes.func.isRequired,
    goToCart: PropTypes.func.isRequired,
    
    modalId: PropTypes.string,
    errorHeading: PropTypes.object.isRequired,
    errorMessage: PropTypes.object.isRequired,
    cashbotName: PropTypes.string,
    submit: PropTypes.func.isRequired,
    isCreditCardPayment: PropTypes.bool
};

const mapStateToProps = state => ({
    activePromoCode: getActivePromo(state) ? getActivePromo(state).get('promoCode') : null
});

const mapDispatchToProps = {
    removeRewards: removePromoRewards,
    addInvalidPromo: setRejectedPromo,
    resetPayment: paymentReset,
    goToCart: setCartStatusReady
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(PromoErrorModal));
